import * as types from '../../actions/actionTypes';
import initialState from '../initialState';


export default function portalContactPersonListReducer(state = initialState.portalContacts, action) {
    let newState = {...state};
    let newData = [];

    switch (action.type) {
        case types.LOAD_PORTAL_CONTACTS_SUCCESS:
            return action.portalContacts;
        case types.DELETE_PORTAL_CONTACT_SUCCESS:
            newState = {...state};
            newState.data = newState.data.filter(pc => pc.id !== action.id);
            newState.total = newState.total - 1;
            return newState;
        case types.UPDATE_PORTAL_CONTACT_SUCCESS:

            const index = _.findIndex(state.data, { id: action.portalContact.id });

            if (index === undefined) {
                return state;
            }
            newData = [...newState.data];
            newData.splice(index, 1, action.portalContact);
            newState.data = newData;
            return newState;
        case types.CREATE_PORTAL_CONTACT_PERSON_SUCCESS:
            let formattedCreated = formatSingle(action.portalContact);
            return [...state, ...formattedCreated];
        default:
            return state;
    }
}

function format(portalContacts) {
    let result = Array.from(portalContacts);

    result.forEach((contact) => {
        contact.departmentId = contact.department.id;
        contact.departmentName = contact.department.name;
        contact.portalId = contact.portal.id;
        contact.portalName = contact.portal.name;
    });

    return result;
}

function formatSingle(portalContact) {
    let contact = {...portalContact};
    contact.departmentId = contact.department.id;
    contact.departmentName = contact.department.name;
    contact.portalId = contact.portal.id;
    contact.portalName = contact.portal.name;
    return contact;
}


// WEBPACK FOOTER //
// ./web/src/reducers/portal/portalContactPersonListReducer.js